import React, { useState } from 'react';
import { AlertCircleIcon, CheckIcon, Loader2Icon } from 'lucide-react';
import { Button } from '../ui/Button';
import { TextField } from '../ui/Field';
import { useAdminData } from '../../contexts/AdminDataContext';
import type { PasswordChangeResult } from '../../contexts/AdminDataContext';
const errorMessages: Record<Exclude<PasswordChangeResult, 'ok'>, string> = {
  'wrong-current': 'Den nuværende adgangskode er forkert.',
  mismatch: 'De to nye adgangskoder er ikke ens.',
  'too-short': 'Den nye adgangskode skal være mindst 8 tegn.',
  failed: 'Adgangskoden kunne ikke ændres. Prøv igen, eller log ud og ind.'
};
export function SecuritySection() {
  const {
    changePassword,
    user
  } = useAdminData();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [working, setWorking] = useState(false);
  const [result, setResult] = useState<PasswordChangeResult | null>(null);
  return <section className="mt-8 max-w-2xl rounded-card border border-line bg-white p-6" data-id="element-373" data-mp="dzqfo2fdn2s9">
      <h2 className="font-display text-lg font-bold tracking-tight text-ink" data-id="element-374" data-mp="99a1uh7n9f5d">Sikkerhed</h2>
      <p className="mt-2 text-sm text-ink-soft" data-id="element-375" data-mp="97gt8wdh0kuq">
        Skift adgangskoden til admin. Adgangskoden håndteres udelukkende af Firebase Authentication og gemmes
        aldrig i databasen eller i browseren.
      </p>
      {user?.email && <p className="mt-2 text-sm text-ink-muted" data-id="element-376" data-mp="wz4f2zvvl5q5">Logget ind som {user.email}</p>}

      <form className="mt-5" onSubmit={async event => {
      event.preventDefault();
      if (working) return;
      setWorking(true);
      const outcome = await changePassword(current, next, confirm);
      setResult(outcome);
      if (outcome === 'ok') {
        setCurrent('');
        setNext('');
        setConfirm('');
      }
      setWorking(false);
    }} data-id="element-377" data-mp="rz9okxg0ii5m">
        <div className="grid gap-5" data-id="element-378" data-mp="33nr36mun2t1l">
          <TextField id="sec-nuvaerende" label="Nuværende adgangskode" type="password" required autoComplete="current-password" value={current} error={result === 'wrong-current' ? errorMessages['wrong-current'] : undefined} onChange={event => {
          setCurrent(event.target.value);
          setResult(null);
        }} data-id="element-379" data-mp="356hm4i2llkus" />
          <div className="grid gap-5 sm:grid-cols-2" data-id="element-380" data-mp="2meyhy7wu80r6">
            <TextField id="sec-ny" label="Ny adgangskode" type="password" required autoComplete="new-password" hint="Mindst 8 tegn." value={next} error={result === 'too-short' ? errorMessages['too-short'] : undefined} onChange={event => {
            setNext(event.target.value);
            setResult(null);
          }} data-id="element-381" data-mp="2r6q322x85e9x" />
            <TextField id="sec-bekraeft" label="Bekræft ny adgangskode" type="password" required autoComplete="new-password" value={confirm} error={result === 'mismatch' ? errorMessages.mismatch : undefined} onChange={event => {
            setConfirm(event.target.value);
            setResult(null);
          }} data-id="element-382" data-mp="28ffgtz2g1pod" />
          </div>
        </div>

        <div className="mt-6 flex flex-wrap items-center gap-4" data-id="element-383" data-mp="27rq3my88ffaz">
          <Button type="submit" disabled={working || !current || !next || !confirm} data-id="element-384" data-mp="22upv8gnwu0gp">
            {working ? <>
                <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-385" data-mp="2hiks898yaqzl" />
                Skifter …
              </> : 'Skift adgangskode'}
          </Button>

          {result === 'ok' && <p role="status" className="flex items-center gap-2 text-[15px] text-ink" data-id="element-386" data-mp="2lkpl35rkrjl6">
              <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-accent-soft text-accent-deep" data-id="element-387" data-mp="2liuxfjox5dde">
                <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-388" data-mp="ou39i909rha4" />
              </span>
              Adgangskoden er blevet ændret
            </p>}

          {result && result !== 'ok' && <p role="alert" className="flex items-start gap-2 text-[15px] text-danger" data-id="element-389" data-mp="xngaly8hlp7a">
              <AlertCircleIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-390" data-mp="wxloric4acs" />
              {errorMessages[result]}
            </p>}
        </div>
      </form>
    </section>;
}